const formatWithCountry = (country, ddd, first, last) => `+${country} (${ddd}) ${first}-${last}`;
const formatLocal = (ddd, first, last) => `(${ddd}) ${first}-${last}`;

export function formatPhoneBR(input) {
  if (input == null || input === '') return '';
  const digits = String(input).replace(/\D/g, '');
  if (!digits) return '';

  // With country code (55) or any 2-digit country code
  if (digits.length === 12) {
    const m = digits.match(/^(\d{2})(\d{2})(\d{4})(\d{4})$/);
    if (!m) return String(input);
    return formatWithCountry(m[1], m[2], m[3], m[4]);
  }

  if (digits.length === 13) {
    const m = digits.match(/^(\d{2})(\d{2})(\d{5})(\d{4})$/);
    if (!m) return String(input);
    return formatWithCountry(m[1], m[2], m[3], m[4]);
  }

  // Without country code (assume BR DDD)
  if (digits.length === 10) {
    const m = digits.match(/^(\d{2})(\d{4})(\d{4})$/);
    if (!m) return String(input);
    return formatLocal(m[1], m[2], m[3]);
  }

  if (digits.length === 11) {
    const m = digits.match(/^(\d{2})(\d{5})(\d{4})$/);
    if (!m) return String(input);
    return formatLocal(m[1], m[2], m[3]);
  }

  return String(input);
}

/**
 * Máscara de input para react-input-mask a partir do valor atual do campo.
 * BR (99) 9999-9999 / (99) 99999-9999 ou +99 (99) ... com código de país.
 * Ao atingir 10 dígitos a máscara expande para 11 slots, permitindo digitar
 * o nono dígito do celular (evita o deadlock do `<= 10`).
 */
export function getPhoneInputMask(value) {
  const d = String(value ?? '').replace(/\D/g, '');
  if (d.length < 10) return '(99) 9999-9999';
  if (d.length <= 11) return '(99) 99999-9999';
  if (d.length <= 12) return '+99 (99) 9999-9999';
  return '+99 (99) 99999-9999';
}

export function getContactDisplayName(contact) {
  if (!contact) return 'Contato sem nome';

  const rawName = String(contact.name || '').trim();
  if (rawName) {
    const onlyDigits = /^\+?\d+$/.test(rawName.replace(/\s+/g, ''));
    if (!onlyDigits) return rawName;
  }

  const phone = contact.number || rawName;
  const formatted = formatPhoneBR(phone);
  return formatted || 'Contato sem nome';
}
